export const Data = [
  {
    type: "zh",
    imgBoxUrl:"https://www.victrum.com/image/tp/产品技术banner.png",
    numList : [
      {
        num : "1",
        tital : "产品介绍",
        path: "cpjs"
      },
      {
        num : "2",
        tital : "全能手机",
        path: "gzj"
      },
      {
        num : "3",
        tital : "工作尖",
        path: "sb"
      }
    ],
    productData:[
    {
      num : "1",
      showData:true,
      text1:"口腔Er:YAG激光治疗仪",
      text2:"口腔Er:YAG激光治疗仪",
      text3:"采用军工级别的Er:YAG晶体，产生波长为2940nm的激光，通过手机动态聚焦技术与口腔组织中水分子的作用，产生“微爆破”反应，实现口腔软、硬组织的汽化，消融切割等治疗效果。\n" +
        "口腔Er:YAG激光对组织表面的温度影响微乎其微，是目前口腔激光治疗领域中高效、安全、微创的治疗方式。\n" +
        "口腔Er:YAG激光治疗仪可以广泛应用于口腔治疗的各个学科，尤其在牙周、种植、正畸、美学、儿牙方面有着明显的临床优势。",
      img1:"https://www.victrum.com/image/tp/产品技术-产品1图.png",
      img2:"https://www.victrum.com/image/nr/cpjs/1-1.jpg",
      img3:"https://www.victrum.com/image/tp/产品技术-产品1-2图.png",


    },
    {
      showData:false,
      num : "2",
      text1:"激光全能手机",
      text2:"激光全能手机",
      text3:"该设备采用直弯头设计，能够实现全方位、多角度的诊疗模式，支持360度自由旋转，操作灵活轻巧，极大提升了使用的便捷性。手柄内置激光发生器，配备第三代内置手柄能量直接传输技术，确保激光能量的高效传输，无任何能量损耗。无需光纤、关节臂或高耗易损件，降低了设备的故障率，简化了设备的维护流程。此外，该设备体积小巧，便于移动，有效提高了设备的使用率和诊疗效率。",
      img1:"https://www.victrum.com/image/tp/产品技术-产品2图.png",
      img2:"https://www.victrum.com/image/nr/cpjs/2-1.jpg",
      img3:"https://www.victrum.com/image/nr/cpjs/2-2.jpg",


    },
    {
      showData:false,
      num : "3",
      text1:"激光工作尖",
      text2:"激光工作尖",
      text3:"非侵入式及吸附锁式设计，达到即插即用，拥有各种直径和长度的规格，可接受高温消毒，实现重复使用，降低使用成本。",
      img1:"https://www.victrum.com/image/nr/cpjs/3.png",
      img2:"https://www.victrum.com/image/nr/cpjs/3-1.jpg",
      img3:"https://www.victrum.com/image/nr/cpjs/3-2.jpg",


    }
    ]
  },
  {
    type: "en",
    imgBoxUrl:"https://www.victrum.com/image/tp/产品技术banner.png",
    numList : [
      {
        num : "1",
        tital : "Product Technology",
        path: "cpjs"
      },
      {
        num : "2",
        tital : "All-in-One",
        path: "gzj"
      },
      {
        num : "3",
        tital : "Working Tips",
        path: "sb"
      }
    ],
    productData:[{
      text1:"Er:YAG Dental Laser Treatment System",
      text2:"Er:YAG Dental Laser Treatment System",
      text3:"Utilizing military-grade Er:YAG crystals, this system generates a 2940nm wavelength laser. Through dynamic focusing technology in the handpiece, it interacts with the water molecules in oral tissues, creating a \"micro-explosion\" effect that enables vaporization, ablation, and cutting of both soft and hard tissues in the oral cavity.\n" +
        "The Er:YAG dental laser has minimal impact on the surface temperature of tissues, making it one of the most efficient, safe, and minimally invasive treatment options available in the field of dental laser therapy today.\n" +
        "This system can be widely applied across various dental disciplines, with significant clinical advantages in periodontics, implantology, orthodontics, aesthetics, and pediatric dentistry.",
      img1:"https://www.victrum.com/image/tp/产品技术-产品1图.png",
      img2:"https://www.victrum.com/image/nr/cpjs/1-1.jpg",
      img3:"https://www.victrum.com/image/tp/产品技术-产品1-2图.png",


    },
    {
      text1:"All-in-One Laser Handpiece",
      text2:"All-in-One Laser Handpiece",
      text3:"This device features a straight and angled head design, allowing for full-range, multi-angle treatment. It supports 360-degree free rotation, offering excellent flexibility and maneuverability, significantly enhancing ease of use. The handpiece contains a built-in laser generator and is equipped with third-generation direct energy transmission technology, ensuring 100% laser energy transmission without any loss.\n" +
        "It eliminates the need for fiber optics, articulated arms, or high-maintenance consumable components, reducing equipment failure rates and simplifying maintenance. Additionally, its compact size makes it easy to move, improving the device's usage rate and treatment efficiency.",
      img1:"https://www.victrum.com/image/产品技术-产品2图.png",
      img2:"https://www.victrum.com/image/nr/cpjs/2-1.jpg",
      img3:"https://www.victrum.com/image/nr/cpjs/2-2.jpg",


    },
    {
      text1:"Laser Working Tips",
      text2:"Laser Working Tips",
      text3:"(3)The non-invasive, lock-in design allows for easy, plug-and-play use. Available in various diameters and lengths, the tips are autoclavable for high-temperature sterilization, enabling repeated use and significantly reducing operational costs.",
      img1:"https://www.victrum.com/image/nr/cpjs/3.png",
      img2:"https://www.victrum.com/image/nr/cpjs/3-1.jpg",
      img3:"https://www.victrum.com/image/nr/cpjs/3-2.jpg",


    }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/js/product.js